'use client';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

const propTypes = {
    /**
   * @deprecated
   * This is no longer supported for consistent user experience
   *
   * By default, the banner segments will be hidden on Small and Extra-Small screens.
   * However, an adaptive design might require that for these screens, the banner be shown elsewhere on the page, separate from the regular Price Bar.
   * In this case, you can create a second Price Bar in a second location on the page, set this option to true, which will force that PriceBar to show its banner (and only its banner) on all screens.
   */ showBannerOnly: deprecatedProp(PropTypes.bool, 'To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.')
};
const propKeysToRemove = Object.keys(propTypes);
const PriceBar = renderWithRef('PriceBar`', propTypes, (props, ref)=>{
    useComponentStylesLoaded('PriceBar', SWAN_STYLE_KEY_MAP.priceBar);
    const { showBannerOnly, children } = props;
    const classNames = new Set([
        'swan-price-bar'
    ]);
    if (showBannerOnly) {
        classNames.add(`swan-price-bar-show-banner`);
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: props
    }, /*#__PURE__*/ React.createElement("div", {
        className: "swan-price-bar-inner"
    }, children)));
});

export { PriceBar };
